document.querySelectorAll('.js-prod-qty').forEach(btn => {
  btn.addEventListener('click', () => {
    const qtyInput = btn.closest('.qty-selector')?.querySelector('input.quantity');
    if (!qtyInput) return;

    const currValue = parseInt(qtyInput.value, 10) || 0;
    const dir = btn.dataset.direction === '+' ? 1 : -1;
    qtyInput.value = Math.max(1, currValue + dir);
  });
});


